const statusHtml = require("./html/status.html");
const actionsHtml = require('./html/actions.html');
import $ from 'jquery';
import _ from "underscore";
import run from '../../../utilities/run';
import render from "../../../utilities/render";
import loadModal from "./scheduleReportModal";
import {setElementsFromScope, setOptionsForSelect} from "../../../utilities/selectorHelpers";
import {isPresent} from "../../../utilities/general";
import {bindCheckboxRowItems, addSimpleCheckboxRows} from "../../../utilities/additionalFilterLogic";
import {applySortingRelatedIconsAndSetHiddenFields} from "../../../utilities/filtersLegacy";
import collectDataAttributesFor from "../../../utilities/collectDataAttributesFor";
import {matchChildrenWidthsToParentCols} from "../../../utilities/jqueryDataTableChildren";
import {flipArrowIcon} from "../../../utilities/fontAwesomeHelpers";
import pagination from "../../../components/pagination/pagination";

require("./lookup.less");

// This was developed using inventory as an example, there may be
// unnecessary pieces carried over that were missed in cleanup
run("#lookup-reports-outer", (lookupOuter)=>{
  window.migrateLookupFrontend = true;
  const data = {};

  // set namespace data up-front...cause of namespace garbage
  data.namespace = lookupOuter.data("namespace");
  const noop = (()=>{});

  const elementsMap = {
    table: '.lookup-table',
    paginationOuter: ".pagination",
    searchTextInput: `#${data.namespace}searchText`,
    showAdditionalFilterInput: `#${data.namespace}showAdditionalFilter`,
    additionalFilterOuter: `#${data.namespace}additionalFilter`,
    itemsPerPageSelect: `#${data.namespace}itemsPerPage`,
    sortFieldHiddenInput: `#${data.namespace}sortField`,
    sortTypeHiddenInput: `#${data.namespace}sortType`,
    form: `#${data.namespace}filter-form`,
    emptyDiv: `#${data.namespace}lookup-reports-table .dataTables_empty`,
    clearFilters: `#${data.namespace}clearFilters`,
    tableHeaderItems: ".table-header-item",
    warehouseSelect: "#warehouse-location-id",
    crtIdInp: `.modal-crt-id`,
    // Below is dynamically searched through document because they are dynamically added
    filterStatusCheckboxes: `#${data.namespace}filter-status a input[type="checkbox"]`,
    scheduleReportTableBody: `#${data.namespace}lookup-reports-table`,
  };

  // elements at document scope
  const docElementsMap = {}

  const defaultLookupDataTableOptions = {
    "searching": false,
    "paging": false,
    "ordering": false,
    "info": false,
  }

  const els = {};
  // Should Be Using Store Pattern,
  // but don't have time to fully overhaul,
  // so we will just store all data in const data

  setElements();
  setData();

  els.sortFieldHiddenInput.val('crtName');
  els.sortTypeHiddenInput.val('asc');
  els.itemsPerPageSelect.val(els.table.data("reports").page.size);

  const paginator = pagination(els.lookupOuter, {
    tableData: data.reports,
    lang: data.lang
  });

  const statusClassMap = {
    "Scheduled": "q-pill-blue q-pill-stretch",
    "Not Scheduled": "q-pill-light-grey q-pill-stretch"
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, lookupOuter);
    setElementsFromScope(els, docElementsMap, $(document));
    els.lookupOuter = lookupOuter;
  }

  function setData(){
    setReportsData(els.table.data("reports"));
    data.filterReportsUrl = els.lookupOuter.data("filter-reports-url");
    data.exportReportsUrl = els.lookupOuter.data("export-reports-url");
    data.viewReportUrl = els.lookupOuter.data("view-report-url");
    data.getReportParamsUrl = els.lookupOuter.data("get-report-params-url");
    data.scheduleReportUrl = els.lookupOuter.data("schedule-report-url");

    data.lang = collectDataAttributesFor(els.lookupOuter.get(0), {prefix: "lang", camelize: false});
  }

  function setReportsData(d){
    data.reports = d;
  }

  const lookUpdateDataTable = els.table.dataTable({
    ...defaultLookupDataTableOptions,
    data: data.reports.content,
    "columnDefs": [
    ],
    columns: [
      {
        data: "crtName",
        render: renderCrtName
      },
      {
        data: "crtDescription"
      },
      {
        data: "schedulingStatus",
        render: renderSchedulingStatus
      }/*,
      {
        data: "actions",
        render: renderActions
      }*/
    ]
  });

  function renderCrtName(crtName, type, row) {
    let url = data.viewReportUrl + "&crtId=" + row.crtId;
    return "<a href='" + url + "'>" + crtName + "</a>";
  }

  function getStatusClass(val){
    return statusClassMap[val];
  }

  function renderSchedulingStatus(data, type, row) {
    return render(
      statusHtml,
      {
        statusText: data,
        statusClass: getStatusClass(row.schedulingStatus)
      }
    )
  }

  function renderActions(data, type, row) {
    return "<a class='ri-link-icon schedule-report' href='#'><i class='fa fa-history fa-lg'/></a>";
    //onClick='onScheduleReportButtonClick(" + row.crtId + ")'
  }

  els.tableHeaderItems.on("click", onTableHeaderItemClick);

  function onTableHeaderItemClick(){
    const headerElement = $(this);
    applySortingRelatedIconsAndSetHiddenFields({
      headerElement,
      elements: els,
      sortField: headerElement.data('sort-field'),
      callback: postLookupSearchHelper
    });
  }

  els.scheduleReportTableBody.on('click', '.schedule-report', onScheduleReportButtonClick);

  function onScheduleReportButtonClick() {
    let rowData = lookUpdateDataTable.api().row($(this).closest('tr')).data();
    //console.log('lookup.data.getReportParamsUrl - ', data.getReportParamsUrl);
    //console.log('rowData.crtId - ', rowData.crtId);
    loadModal(data.getReportParamsUrl, data.scheduleReportUrl, rowData.crtId);
  }

  const debouncedColWidthMatcher = _.debounce(()=>{
    matchChildrenWidthsToParentCols({table: els.table});
  }, 50);

  // Make sure all child row td's match the parent table
  // header col width's on resize (jquery dataTable
  // plugin is using some computation other than percent
  // to set the col widths on resize, so we must compensate)
  $(window).resize(debouncedColWidthMatcher);

  // This event notably comes from the backend js file,
  // this is a work-around for now to allow the abundance of
  // triggerSearch calls to be ported to the front
  els.lookupOuter.on('exec-search', handleExecSearchEvent);

  function handleExecSearchEvent(e, pageNumber){
    postLookupSearchHelper({pageNumber});
  }

  function postLookupSearchHelper({pageNumber=0}={}){
    postLookupSearch({pageNumber: pageNumber, elements: els, success: receivePostLookupSearch});
  }


  function collectStatusValues(){
    return _($(elementsMap.filterStatusCheckboxes).filter(":checked").toArray()).map((el)=>{
      return $(el).val();
    })
  }

  let searchRequest;

  function postLookupSearch(options={}) {
    //console.log("postLookupSearch - start");
    //console.log(data.filterReportsUrl);
    const {elements, pageNumber, size, orderBy, orderByType, url, success=noop, error=noop} = options;
    // Show loading overlay
    if(searchRequest){
      searchRequest.abort();
    }

    searchRequest = $.ajax({
      url: url || data.filterReportsUrl,
      type: 'POST',
      data: getCurrentPageDataForSearch(options),
      dataType: 'JSON',
      // DONT DO THIS
      // async: false,
      success: function(data) {
        //console.log("postLookupSearch.ajaxSuccess - start");
        // hide loading overlay
        searchRequest = null;
        success(data);
        //console.log("postLookupSearch.ajaxSuccess - finish");
      },
      error: error
    });
    //console.log("postLookupSearch - finish");
  };


  function receivePostLookupSearch(newData){
    //console.log("receivePostLookupSearch");
    lookUpdateDataTable.fnClearTable();
    setReportsData(newData);
    if (data.reports.content.length > 0) {
      lookUpdateDataTable.fnAddData(data.reports.content);
    }
    else {
     els.emptyDiv.text(data.lang['lookup-filter-no-results-found']);
    }
    paginator.setTableData(data.reports);
  }

  function getCurrentPageDataForSearch({elements=els, pageNumber, size, orderBy, orderByType}){
    const dataStr = elements.form.serialize();
    const additionalDataStr = $.param({
      [`${data.namespace}page`]: (isPresent(pageNumber) ? pageNumber : 0),
      [`${data.namespace}size`]: (isPresent(size) ? size : elements.itemsPerPageSelect.val()),
      [`${data.namespace}orderBy`]: (isPresent(orderBy) ? orderBy : elements.sortFieldHiddenInput.val()),
      [`${data.namespace}orderByType`]: orderByType || elements.sortTypeHiddenInput.val(),
    });

    //console.log("getCurrentPageDataForSearch - finish");
    return dataStr + "&" + additionalDataStr;
  }

  const filterFields = [
    {
      value: "crtName",
      text: "Report Name"
    },
    {
      value: "crtDescription",
      text: "Description"
    },
    {
      value: "schedulingStatus",
      text: "Status"
    }
  ];

  // setOptionsForSelect({
  //   selectElement: els.filterFieldsSelect,
  //   list: filterFields,
  //   initialSelectValue: "crtName"
  // });
});



// WEBPACK FOOTER //
// ./src/pages/report/lookup/lookup.js